'use strict';
import $ from 'jquery';

$(document).ready(function () {
    $('.cart__item-quantity-btn--minus').click(function () {
        updateQuantity($(this), false);
    });

    $('.cart__item-quantity-btn--plus').click(function () {
        updateQuantity($(this), true);
    });
});

function updateQuantity (self, add) {
    const input = self.parent().find('.cart__item-quantity-input');
    const remove = self.parent().find('.cart__item-quantity-remove').attr('href');
    let value = input.val();

    if (add) {
        value++;
    } else {
        value--;
    }

    if (value === 0 || value < 0) {
        window.location.href = remove;
        return;
    }

    input.val(value);

    $('#cart_form').submit();
}
